import React from 'react'
import { Grid, Typography, styled } from '@the-platform-group/component-library'
import { usePeopleMergeContext } from '../contexts/PeopleMergeContext'
import { getProfileFieldValue } from '../utils'

export const StyledCell = styled(Grid, {
  shouldForwardProp: prop => prop !== 'filled',
})(({ theme, filled }) => ({
  padding: theme.spacing(1),
  display: 'flex',
  alignItems: 'center',
  ...(filled && {
    backgroundColor: theme.palette.background.secondary.default,
  }),
}))

const ComparisonRow = ({ field }) => {
  const { mergeData } = usePeopleMergeContext()
  const { sourcePerson, targetPerson } = mergeData.selectedData
  const { preview } = mergeData.mergePreviewMeta
  const sourceValue = getProfileFieldValue({
    person: sourcePerson,
    preview,
    fieldKey: field.key,
    isSource: true,
  })
  const targetValue = getProfileFieldValue({
    person: targetPerson,
    preview,
    fieldKey: field.key,
    isSource: false,
  })

  return (
    <Grid item container sx={{ borderBottom: '1px solid', borderColor: 'border.secondary' }}>
      <StyledCell filled item xs={2}>
        <Typography variant="body2" fontWeight="medium">
          {field.label}
        </Typography>
      </StyledCell>
      <StyledCell item xs={5}>
        <Typography variant="body2">{sourceValue}</Typography>
      </StyledCell>
      <StyledCell item xs={5}>
        <Typography variant="body2">{targetValue}</Typography>
      </StyledCell>
    </Grid>
  )
}

export default ComparisonRow
